document.addEventListener('DOMContentLoaded', function () {
  /** ==========================
   * PRODUCT GRID IMAGE SWAP
   * ===========================
   */
  const productGrids = document.querySelectorAll('.grid.product-grid');

  productGrids.forEach((productGrid) => {
    const sectionId = productGrid.getAttribute('data-section-id');
    if (!sectionId) return;

    const variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];

    productGrid.addEventListener('change', (e) => {
      const radio = e.target;
      if (!radio.matches(`input[type="radio"][data-section-id="${sectionId}"]`)) return;

      const card = radio.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
      if (!card) return;

      const productImage = card.querySelector('.card__media img');
      if (!productImage) return;

      const variantId = radio.getAttribute('data-variant-id');
      const imageUrl = radio.getAttribute('data-image-url');
      const lazyLoad = card.getAttribute('data-lazy-load-all-variants') === 'true';
      const variantData = variantDataMap ? variantDataMap[variantId] : null;

      // Save default image if not already saved
      if (!card.dataset.defaultImageSrc) {
        card.dataset.defaultImageSrc = productImage.src;
        card.dataset.defaultImageSrcset = productImage.srcset || '';
      }

      // === Image Swap ===
      if (lazyLoad) {
        const preloadedImage = card.querySelector(`img[data-variant-id="${variantId}"]`);
        if (preloadedImage) {
          productImage.src = preloadedImage.src;
          productImage.srcset = preloadedImage.srcset || '';
        } else if (imageUrl) {
          productImage.src = imageUrl;
          productImage.removeAttribute('srcset');
        }
      } else if (variantData?.imageUrl) {
        const dynamicSrcset = [
          `${variantData.imageUrl}?width=165 165w`,
          `${variantData.imageUrl}?width=360 360w`,
          `${variantData.imageUrl}?width=533 533w`,
          `${variantData.imageUrl}?width=720 720w`,
          `${variantData.imageUrl}?width=940 940w`,
          `${variantData.imageUrl}?width=1066 1066w`,
        ].join(', ');
        productImage.src = variantData.imageUrl;
        productImage.srcset = dynamicSrcset;
      } else if (imageUrl) {
        productImage.src = imageUrl;
        productImage.removeAttribute('srcset');
      }

      // === Restore image on mouse leave ===
      const restoreDefault = () => {
        if (card.dataset.defaultImageSrc) {
          productImage.src = card.dataset.defaultImageSrc;
          if (card.dataset.defaultImageSrcset) {
            productImage.srcset = card.dataset.defaultImageSrcset;
          } else {
            productImage.removeAttribute('srcset');
          }
        }
        card.removeEventListener('mouseleave', restoreDefault);
      };

      card.addEventListener('mouseleave', restoreDefault);
    });
  });

  /** ==========================
   * PRODUCT PAGE IMAGE SWAP
   * ===========================
   */
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  productForms.forEach((form) => {
    const productGallery = form.closest('.product')?.querySelector('.product__media img');
    if (!productGallery) return;

    // Save default image once
    if (!form.dataset.defaultImageSrc) {
      form.dataset.defaultImageSrc = productGallery.src;
      form.dataset.defaultImageSrcset = productGallery.srcset || '';
    }

    form.addEventListener('change', (e) => {
      const radio = e.target;
      if (!radio.matches('input[type="radio"][name*="options"]')) return;

      const imageUrl = radio.getAttribute('data-image-url');
      if (imageUrl) {
        productGallery.src = imageUrl;
        productGallery.removeAttribute('srcset');
      }
    });

    // Restore image on swatch hover out
    const swatchContainer = form.querySelector('.product-form__input');
    if (swatchContainer) {
      swatchContainer.addEventListener('mouseleave', () => {
        if (form.dataset.defaultImageSrc) {
          productGallery.src = form.dataset.defaultImageSrc;
          if (form.dataset.defaultImageSrcset) {
            productGallery.srcset = form.dataset.defaultImageSrcset;
          } else {
            productGallery.removeAttribute('srcset');
          }
        }
      });
    }
  });
});
